// extracted by css-extract-rspack-plugin
export default {"checkboxLabelRoot":"DashboardCopyModalShallowCheckboxLabel-module__checkboxLabelRoot___B3HtL"};